import { PwaInstallSheet } from "@frontend/components/pwa/PwaInstallSheet";
import { usePwaInstall } from "@frontend/hooks/usePwaInstall";
import { createContext, useContext } from "react";
const Ctx = createContext(null);
export const PwaInstallHost = ({ children, manifestUrl, icon, }) => {
    const state = usePwaInstall();
    return (<Ctx.Provider value={state}>
			{children}
			{/* Our custom MUI-themed bottom sheet handles the install UX so
            the palette matches the rest of the app (belgrade-plus /
            magicbell/pwa-inbox layout, MUI theming). It auto-opens
            on beforeinstallprompt / iOS-Safari, respects a 3-day
            dismissal, and calls back into state.install() below. */}
			<PwaInstallSheet />
			{/* Web component renders hidden — we drive the UX ourselves.
            `disable-chrome` skips its built-in Chromium install dialog;
            `manual-apple manual-chrome` gates the library's dialogs to
            programmatic .install() calls. */}
			<pwa-install ref={state.ref} manifest-url={manifestUrl} icon={icon} disable-chrome="true" manual-apple="true" manual-chrome="true" use-local-storage="true" hidden/>
		</Ctx.Provider>);
};
export const usePwaInstallCtx = () => {
    const ctx = useContext(Ctx);
    if (!ctx) {
        throw new Error("usePwaInstallCtx must be used inside <PwaInstallHost>");
    }
    return ctx;
};
